export default {
    environment: process.env['VUE_APP_ENVIRONMENT']||'mobi' // app, mobi or com for production
}